import api from '..'

const requests = {
    fetchEdition: async () => {
        try {
            var response = await api.get(`/wellful/Edition`)
            return response.data
        } catch (error) {
            throw error.response ? error.response.status : error
        }
    }
}

export default requests
